
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, ElementRef, NgModule } from '@angular/core';
import { FileUploader, FileUploadModule, FileUploaderOptions, FileItem } from 'ng2-file-upload';
import { deviceService } from '../shared/servicesHardware/deviceService';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PostJsonObjectService } from '../shared/services/post-json-object.service';
import { first } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MaterialModule } from '../material-module';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-envoi-fichier',
  imports: [CommonModule, FileUploadModule, MatIconModule, MatProgressSpinner, MaterialModule],
  standalone: true,
  templateUrl: './envoi-fichier.html',
  styleUrl: './envoi-fichier.scss'
})
export class EnvoiFichier implements OnInit, AfterViewInit {

  private authToken: string = "";
  public fileUploaders: fileUploaderObject[] = [];
  @ViewChild('inputTypeFile') public inputTypeFile: ElementRef | null = null;

  @Input() idDecalrationappelASupport: string = "";
  @Output() filesSended: EventEmitter<any> = new EventEmitter<any>();
  @Output() componentHeight: EventEmitter<number> = new EventEmitter<number>();

  public uploaders: FileUploader[] = [];
  public uploaderPictures!: FileUploader;
  public filesSendedStatic: boolean[] = [];
  public selectedFileName: string = "";
  public isSending: boolean = false;
  public pictureSended: string[] = [];

  //variables for dropFIleUploader
  @ViewChild('dropZoneInitialText', { static: true }) dropZoneInitialText: any;
  @ViewChild('inputContainer') imgFileInputContainer: any;

  public option: any;
  public template: any;
  public sendingPictureState: number = 0;

  @Input() isReadOnly: Boolean = false;

  constructor(private deviceService: deviceService,
    protected sanitizer: DomSanitizer,
    private postJsonObjectService: PostJsonObjectService,
    public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.authToken = "Bearer " + this.deviceService.decryptDataLocalStorage('userSession').currentUser;
    this.updateASFiles();

    this.uploaderPictures.onCompleteItem = (item: FileItem, response: any, status: any, headers: any) => {
      //TODO catch response (file ID thne link it with current AS)
      console.log("completItem event");

      if (status == 200) {
        console.log("response to a sended file" + response);
        this.attachFileToTicket(response, item);
        //TODO catch response file ID, then link it with current AS (idDecalrationappelASupport)
      }
      else
        this.sendingPictureState = 0;
    };
  }

  public ngOnChanges(changes: any) {
    this.updateASFiles();
    this.uploaderPictures.onCompleteItem = (item: FileItem, response: any, status: any, headers: any) => {
      //TODO catch response (file ID thne link it with current AS)
      if (status == 200) {
        this.attachFileToTicket(response, item);
        //TODO catch response file ID, then link it with current AS (idDecalrationappelASupport)
      }
      else
        this.sendingPictureState = 0;
    };
  }

  private updateASFiles() {
    this.filesSendedStatic = [false, false, false, false, false, false];
    let optionFIleUploader: FileUploaderOptions = { url: '' };
    this.uploaderPictures = new FileUploader(optionFIleUploader);
  }

  private attachFileToTicket(fileDescription: any, item: FileItem) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/html',
      })
    };

    let fileId = JSON.parse(fileDescription).fileUniqueId;
    console.log(fileId);

    this.postJsonObjectService.sendJson("support/tickets/" + this.idDecalrationappelASupport + "/attachments/" + fileId, "test", httpOptions).pipe(
      first()).subscribe(
        result => {
          if (result == "ko") {
            console.log("unable to attache file");
            this.filesSended.emit(false);
            this.sendingPictureState = 0;
          }
          else {
            this.filesSended.emit(result);
            this.sendingPictureState = 2;
            this.pictureSended.push(item._file.name);
          }
        });
  }


  public encodeURI(doc: any): string {
    return encodeURI(environment.url + "support/attachments/" + doc.fileUniqueId + "?access_token=" + this.deviceService.decryptDataLocalStorage('userSession').currentUser);
  }

  public buttonClick(event: any) {
    this.inputTypeFile?.nativeElement.click()
  }

  //methode for drop file uploader 
  ngAfterViewInit() {
    if (this.imgFileInputContainer != null)
      this.imgFileInputContainer._elementRef.nativeElement.childNodes[0].childNodes[2].style.backgroundColor = "transparent";
    // this.uploaderPictures.setOptions({ disableMultipart: true })

  }

  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;
  public innerHTMLdropZone: string = "";

  public imgFileIn(e: any) {
    this.fileDropOnZone(e.srcElement.files);
    // let nodeElem = document.getElementsByClassName('mat-form-field-ripple') as HTMLCollectionOf<HTMLElement>;
    // nodeElem[0].style.opacity = "0";
  }

  public fileOverBase(e: any): void {
    //file overZone (not drop)
    this.hasBaseDropZoneOver = e;
  }

  public onFileInput(event: any) {
    if (event.target.value == null || event.target.value == "")
      return;
    // this.filesSendedStatic[indexUploader] = false;
    // this.filesSended.emit(this.filesSendedStatic);

    // let fileName1: string[] = event.target.value.split('/');
    // let fileName2: string[] = fileName1[fileName1.length - 1].split('\\');
    // fUploader.selectedFileName = fileName2[fileName2.length - 1];

    // let urlLocation = window.location.hostname
    // if (urlLocation.includes("localhost"))
    //   urlLocation = "https://dev.guemas-associes.fr"
    // else
    //   urlLocation = "https://" + window.location.hostname


    // let optionFIleUploader: FileUploaderOptions =
    // {
    //   disableMultipart: true,
    //   url: urlLocation + apiFlowConfig.apiUrl + "declarations-sinistres-vehicules/" + this.idDecalrationSinistre + "/documents/" + fUploader.typeFile + "/" + fUploader.selectedFileName,
    //   authToken: this.authToken,
    //   headers: [{ name: 'Content-type', value: 'application/octet-stream' }]
    // }
    // fUploader.sendingState = 1;
    // fUploader.uploader.setOptions(optionFIleUploader);
    // fUploader.uploader.uploadAll();
  }

  public fileDropOnZone(files: any) {
    if (files.length != 1) {
      for (let i = 0; i < files.length; i++) {
        for (let j = 0; j < this.uploaderPictures.queue.length; j++) {
          if (files[i].name == this.uploaderPictures.queue[j]._file.name)
            this.uploaderPictures.removeFromQueue(this.uploaderPictures.queue[j]);
        }
      }
      return;
    }
    this.sendingPictureState = 1;
    this.filesSended.emit(false);
    let fileAlreadyExist: boolean;
    fileAlreadyExist = false;

    for (var j = 0; j < this.pictureSended.length; j++) {
      if (this.pictureSended[j] == files[0].name) {
        console.log("file already exist : " + files[0].name);
        fileAlreadyExist = true;
      }
    }
    //envoy automatique des fichiers
    if (!fileAlreadyExist) {
      let optionFIleUploader: FileUploaderOptions =
      {
        url: environment.url + "files/" + files[0].name,
        authToken: this.authToken,
        disableMultipart: true,
        headers: [{ name: 'Content-type', value: 'application/octet-stream' }]
      };
      this.uploaderPictures.setOptions(optionFIleUploader);
      this.uploaderPictures.queue[(this.uploaderPictures.queue.length - 1)].upload();
    }

    this.dropZoneInitialText.nativeElement.className = "dropZoneInitialTextNotDisplay";
    if (fileAlreadyExist) {
      this.openSnackBar();
    }
  }

  public updateType(typeStr: any): string {

    let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIEOrEdge)
      return "noDisplayPlugin";

    if (typeStr.type.match('audio.*') || typeStr.name.match(/\.(ogg|mp3|wav)$/i)) {
      return "audio";
    }
    else if (typeStr.type.match('video.*') || typeStr.name.match(/\.(og?|mp4|webm|3gp)$/i)) {
      return "video";
    }
    else if (typeStr.type.match('image.*') || typeStr.name.match(/\.(gif|png|jpe?g)$/i)) {
      return "image";
    }
    else if (typeStr.name.match(/\.(pptx|xlsx|docx)$/i)) {
      return "office";
    }
    else //display object using navigator mime type
    {
      return "default";
    }
  }

  public setUploader(uploader: FileUploader) {
    this.uploaderPictures = uploader;
  }

  public deleteElem(item: any) {
    this.uploaderPictures.removeFromQueue(item);
  }

  public getBlob(item: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(item._file));
  }

  public getType(item: any): string {
    return item._file.type;
  }

  openSnackBar() {
    this.snackBar.openFromComponent(fileAlreadyInComponent, {
      duration: 2000
    });
  }

}


@Component({
  selector: 'file-already-in-component',
  standalone: true,
  imports: [ MatIconModule],
  template: `<span class="snackBar">
                <span class="marginIcon"><mat-icon>warning</mat-icon></span>Fichier déja présent 
              </span>`,
  styles: [`
    .snackBar {      
      color: white;
      font-size : 1.3em;
      text-align:center;
      font-style : italic;
      vertical-align : middle;
      display: inline-flex;
    }
    .marginIcon{
      margin-right : 20px;
      display: inline-block;
    }
  `],
})
export class fileAlreadyInComponent {


}

export interface fileUploaderObject {
  fileAlreadyExist: boolean; //use for display or not input file field
  uploader: FileUploader, //uploader for the file
  sendingState: number, //use for display loading-spinner/loaded-ok/nothing
  typeFile: string, //use for specify 
  selectedFileName: string, //file name string display in html
  fileLink: string,
  placeHolder: string,
  displayFile: boolean;
}

